import { useState } from "react"
import { produce } from "immer"
import { BsEyeFill } from "react-icons/bs"
import { HxMapGroup } from "../../../../Comps/HxMap/HxMapGroup"
import { NotesSelectMenu } from "../../../../Comps/NoteButtons/NotesSelect"
import { HexMap } from "../../../../Data/HexMap/HexMap"
import { HexMapBuilderParams, BuildHexMap } from "../../../../Data/HexMap/HexMapBuilder"
import { HexMapModifier } from "../../../../Data/HexMap/HexMapModifier"
import { Note } from "../../../../Data/HexMap/Note"
import { FlexRowTwo } from "../../../../Layouts/FlexRows"
import { useNoteNames } from "../../../../Project/ProjectStore"
import { All } from "../../../../Util/Constants/Quantities"
import { Music, useScaleNotes } from "../../../../Util/Music/Music"
import { TransformTranslate } from "../../../../Util/Transform/Transform"
import { IconEye } from "../../../../Comps/Icons/IconEye"
import { CommonNotes } from "../CommonNotes"

export function CycleChromaticPair(){ 
    const [tonic, setTonic] = useState(Music.G)
    const getAdjustedTonic = (t:number) => { return t }
    const getMap = () => {
        const params:HexMapBuilderParams = {rows:2, columns:2, tonic:getAdjustedTonic(tonic), radius:80}
        const map:HexMap = BuildHexMap(params)
        const mod:HexMapModifier = new HexMapModifier(map)
        mod.keys_setOpen([0,3], true)
        mod.keys_setOpen([1,2], false)
        mod.keys_setVisible([1,2], false)
        //mod.notes_setPrimaryLabelAsNoteIndex([All])
        return map
    }
    const [map, setMap] = useState<HexMap>(getMap())
    const [width,height] = [500,400]
    const onNoteClick = (note:Note) => {
        setMap(produce((draft:HexMap)=>{
            const mod:HexMapModifier = new HexMapModifier(draft)
            mod.notes_advanceSelectedState([note.params.noteIndex])
        }))
    }
    const resetTonic = (t:number) => {
        setTonic(t)
        setMap(produce((draft:HexMap)=>{
            const mod:HexMapModifier = new HexMapModifier(draft)
            mod.setTonic(getAdjustedTonic(t))
        }))
    }
    const commonNoteIndexes:number[] = [3,17,0,19]
    const showCommonNotes = () => {
        const noteIndexes:number[] = commonNoteIndexes
        setMap(produce((draft:HexMap)=>{
            const mod:HexMapModifier = new HexMapModifier(draft)
            mod.notes_setDefault([All])
            mod.notes_setSelected(noteIndexes)
        }))
    }
    const showCommonChords = () => {
        const noteIndexes:number[] = []
        setMap(produce((draft:HexMap)=>{
            const mod:HexMapModifier = new HexMapModifier(draft)
            mod.notes_setDefault([All])
            mod.notes_setHilited(noteIndexes)
        }))
    }
    const showPowerChord = () => {
        const noteIndexes:number[] = [3,17,0,19]
        setMap(produce((draft:HexMap)=>{
            const mod:HexMapModifier = new HexMapModifier(draft)
            mod.notes_setDefault([All])
            mod.notes_setHilited(noteIndexes)
        }))
    }
    const showNotes = (noteIndexes:number[]) => {
        setMap(produce((draft:HexMap)=>{
            const mod:HexMapModifier = new HexMapModifier(draft)
            mod.notes_setDefault([All])
            mod.notes_setHilited(noteIndexes)
        }))
    }
    const noteNames:string[] = useNoteNames()
    const leftTonicNote:string = noteNames[tonic]
    const rightTonicNote:string = noteNames[(tonic + 1) % 12]
    const scale:string[] = useScaleNotes(tonic)
    const clear = () => {
        setMap(getMap())
    }
    return(
        <div className={'harmonic-cycle-pair'}>
            <FlexRowTwo columnOneFlex={1} columnTwoFlex={1}>
               <div className={'centered'} style={{marginTop:30}}> 
                    <div><NotesSelectMenu onChange={resetTonic} tonic={tonic}/></div>
                    <svg width={width} height={height} className={'pair-hexmap'}>
                        <g transform={TransformTranslate(width/2.5, height/2)}>
                            <HxMapGroup hexMap={map} onNoteClick={onNoteClick}/>
                        </g>
                    </svg>
                    <div><button style={{marginTop:25}} type='button' onClick={clear}>Clear</button></div>
                </div>
                <div className={'pair-description'}>
                    <h2>Properties of Two Keys Along a Cycle of Flat Thirds</h2>
                    <ul>
                        <li>Common Notes: 2 of 7 <CommonNotes map={map} noteIndexes={commonNoteIndexes}/> <IconEye onClick={showCommonNotes}/></li>
                        <li>Common Triadic Chords: 0 of 7<IconEye onClick={showCommonChords}/></li>
                        <li>Common Power Chord: {scale[3]}5<IconEye onClick={showPowerChord}/></li>
                        <li>The bottom right key ({rightTonicNote}) is a flat second (1 note) higher, or a seventh (11 notes) lower than the top left key ({leftTonicNote}).</li>
                        <li>Conversely, the top left key ({leftTonicNote}) is a seventh (11 notes) higher, or a flat second (1 note) lower than the bottom right key ({rightTonicNote})</li>   
                    </ul>
                    <h2>Common Modulation Techniques:</h2>
                    <ul>
                        <li>Chromatic movements</li>
                    </ul>
                    <h2>Parallel Modes (top left key to bottom right key):</h2>
                    <ul>
                        <li>
                            {scale[0]} Ionian (major) in {leftTonicNote} and {scale[0]} Locrian in {rightTonicNote} 
                            <IconEye onClick={()=>{showNotes([0,19])}}/>
                        </li>
                        <li>
                            {scale[3]} Lydian in {leftTonicNote} and {scale[3]} Phrygian in {rightTonicNote} 
                            <IconEye onClick={()=>{showNotes([3, 17])}}/>
                        </li>
                    </ul>
                </div>
            </FlexRowTwo>

        </div>
    )
}